<template>
  <div :class="mc_field">
    <div :class="_icon_"></div>
    <div style="float: left;position: absolute;margin-left: 2%">
      <slot name="lable"></slot>
    </div>
    <input ref="input"
           :type="type"
           :class="_input_"
           :placeholder="holder"
           :value="value"
           @focus="show()"
           @blur="_hide()"
           @input="$emit('input', $event.target.value)"
            required>
    <span v-if="showFlag" class="editable-clear-x"
          @click="clear()" style="color: #757575;margin-left: 5%">✕
    </span>
    <div style="float: right">
      <slot name="more"></slot>
    </div>
    <div class="_line_"></div>
  </div>
</template>

<script>
  export default {
    name: 'Field',
    display: '输入框',
    data() {
      return {
        preCls: 'mc-field',
        showFlag: true,
        inputValue: null,
      }
    },
    props: {
      event: 'input',
      value: String,
      icon: {
        type: String,
        default: 'disabled',
        validator(value) {
          let types = ['disabled','phone', 'password', 'verification',]
          return types.includes(value) || !value
        }
      },
      holder: String,
      type: {
        type: String,
        default: 'text',
      }
    },
    computed: {
      _icon_() {
        let {icon} = this
        let className = [
          `_icon_`,
          {
            [`_icon_-${icon}`]: !!icon,
          },
        ]
        return className
      },
      mc_field(){
        let {size} = this
        let className = [
          `mc-field`,
          {
            [`mc-field-${size}`]: !!size,
          },
        ]
        return className
      },
      _input_(){
        if (this.$slots['more'] === undefined){
          let className = [
            `invite-code-input`,
          ]
          return className
        } else {
          let className = [
            `invite-code-input-more`,
          ]
          return className
        }

      }
    },
    methods: {
      clear: function () {
        this.$refs.input.value = ''
        this.$emit('input', this.$refs.input.value)
      },
      show: function () {
        this.showFlag = true
      },
      _hide: function () {
        let that = this;
        setTimeout(function()  {
          that.showFlag = false
        },100);
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/field/field.vue